import React, { useState } from 'react';
import axios from 'axios';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [heading, setHeading] = useState('');
  const [images, setImages] = useState([]);
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://royaleva.hxbindia.com/api/subscribe', { email });
      setMessage(response.data.message);
    } catch (error) {
      setMessage('Failed to subscribe.');
    }
  };

  const handleSendNewsletter = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('content', content);
    formData.append('heading', heading);
    images.forEach(image => formData.append('images', image));

    try {
      const response = await axios.post('https://royaleva.hxbindia.com/api/send-newsletter', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage('Failed to send newsletter.');
    }
  };

  const handleImageChange = (e) => {
    setImages([...e.target.files]);
  };

  return (
    <>
      {/* <h1 className="text-4xl font-bold text-center mb-8">Newsletter Test Form</h1> */}
{/* 
      <div className="max-w-md mx-auto bg-white p-8 border rounded-lg shadow-md mb-8">
        <h2 className="text-2xl font-semibold mb-4">Subscribe to Newsletter</h2>
        <form onSubmit={handleSubscribe}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-3 border rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button type="submit" className="w-full bg-blue-500 text-white p-3 rounded hover:bg-blue-600 transition">Subscribe</button>
        </form>
      </div> */}

<div className="container d-flex justify-content-center">
      <div className="col-md-7 pt-5">
        <h1 className="text-danger mb-4">Send Newsletter</h1>
   <ul>     <h4>Steps To Follow</h4>
  <hr />
<li>
  Use "|" to separate or break line.
</li>
<li>
  Maximum 1 images.
</li>

</ul>
        <div className="card shadow p-4">
          <form onSubmit={handleSendNewsletter}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Subject</label>
              <input
                type="text"
                className="form-control"
                placeholder="Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Heading</label>
              <input
                type="text"
                className="form-control"
                placeholder="Heading"
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Content</label>
              <textarea
                className="form-control"
                rows="6"
                placeholder="Content "
                value={content}
                onChange={(e) => setContent(e.target.value)}
                required
              ></textarea>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Images</label>
              <input
                type="file"
                className="form-control"
                multiple
                accept="image/*"
                onChange={handleImageChange}
              />
            </div>

            <button type="submit" className="btn btn-danger w-100">Send Newsletter</button>
          </form>
        </div>

        {message && (
          <div className="alert alert-info text-center mt-4">
            {message}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default NewsletterForm;
